import ReviewerRole from './ReviewerRole'

export default class ValuedReviewer extends ReviewerRole {
  arcDownloadsPerWeek = 10
  totalClaimOverdueDayAllowance = 150
  arcMaxDownloads = -1
  requiredReviewsForTier = 1
  canMessageAuthor = true
  canDownloadAudioBookArcs = true
}
